import React from "react";
import PropTypes from "prop-types";

// Bare-bones mock-up with the only goal to match the UX blueprints visually
export const Footer = () => (
<footer className="pt-12 pb-4 text-center text-xs text-primary-text bg-gradient-to-b from-transparent via-primary-bg to-primary-bg z-10">
  {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
  <p className="text-sm font-normal">First Advantage ®</p>
  {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
  <span>© {new Date().getFullYear()} First Advantage. All rights reserved.</span>
</footer>
);

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
}